export const environment = {
  appName: "Naav",
  production: false,
  apiUrl: 'https://dev-api.naavds.com/',//dev
  apiPrefix: 'api/v1',
  // media_domain: 'https://dev-api.naavds.com/api/v1/admin/getImg/', //dev
   media_domain: 'https://d2a81tus45aasu.cloudfront.net/development', //dev

  OneSignalAppId: "aa684f22-90de-4153-8152-ee041fed9815", //dev
  //OneSignalAppId:"c7115474-0d40-42f2-bee8-7fc94a5ef9dc", //prod

  firebase: {
    apiKey: "AIzaSyB-bmivDdH8X98JiYbFtH6DtnTdbwKAaDg",
    authDomain: "naav-96234.firebaseapp.com",
    databaseURL: "https://naav-96234-default-rtdb.firebaseio.com",
    projectId: "naav-96234",
    storageBucket: "naav-96234.firebasestorage.app",
    messagingSenderId: "124175334978",
    appId: "1:124175334978:web:5406150aedaf26247df7db",
    measurementId: "G-C202M58MVH"

  }

  // test
};